import { useState, useEffect } from "react";

export const MOBILE_SCREEN = 599;

export const useMediaQuery = () => {
  const [targetReached, setTargetReached] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= MOBILE_SCREEN) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }
    window.addEventListener("resize", handleResize);

    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return targetReached;
};
